import { render, staticRenderFns } from "./Abas.vue?vue&type=template&id=0022b153"
import script from "./Abas.vue?vue&type=script&lang=js"
export * from "./Abas.vue?vue&type=script&lang=js"
import style0 from "./Abas.vue?vue&type=style&index=0&id=0022b153&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VBtn,VTab,VTabItem,VTabs,VTabsItems})
